
import Accordion from '@/components/common/Accordion.vue'
import Button from '@/components/UntitledUI/Button.vue'
import Icon from '@/components/UntitledUI/Icon.vue'

import { ObserveVisibility } from 'vue-observe-visibility'
import { debounce } from 'lodash'

export default {
    name: 'SearchFilter',
    components: {
        Accordion,
        Button,
        Icon
    },
    directives: { ObserveVisibility },
    props: {
        title: {
            type: String,
            required: true
        },
        values: {
            type: Array,
            default: () => []
        },
        isActive: {
            type: Boolean,
            default: false
        },
        shouldLoadMore: {
            type: Boolean,
            default: false
        },
        clearValuesFunc: {
            type: Function,
            default: null
        },
        resetFunc: {
            type: Function,
            default: null
        },
        loadMoreFunc: {
            type: Function,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            isOpen: false,
            loading: false,
            topBoundVisible: true,
            bottomBoundVisible: true,
            loadMoreDebounced: null
        }
    },
    computed: {
        shouldBeActive () {
            if (!this.isActive) {
                return false
            }
            return this.isOpen
        }
    },
    watch: {
        isOpen () {
            if (this.isOpen) {
                this.$emit('open')
            }
        },
        shouldBeActive (value) {
            if (!value) {
                this.isOpen = false
            }
        }
    },
    created () {
        if (typeof this.loadMoreFunc === 'function') {
            this.loadMoreDebounced = debounce(this.loadMoreFunc, 400)
        }
    },
    methods: {
        scrollBoundingCheck (bound, visible) {
            this[bound + 'BoundVisible'] = visible
        },
        checkVisibility (visible) {
            if (visible && !this.loading && typeof this.loadMoreFunc === 'function') {
                this.loading = true
                this.loadMoreFunc()
                    .finally(() => {
                        this.loading = false
                    })
            }
        },
        clear () {
            if (typeof this.clearValuesFunc === 'function') {
                this.clearValuesFunc()
            }
        },
        reset () {
            if (typeof this.resetFunc === 'function') {
                this.resetFunc()
            }
        }
    }
}
